'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _requestAppointmentModal = require('../actions/request-appointment-modal');

var _pageActions = require('../actions/page-actions');

var _specialistProfile = require('../transformers/specialist-profile');

var _helpers = require('../../../../src/client/utils/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LAST_TWO_CHARS = -2;

// fixme: this state looks totally broken
var INITIAL_STATE = {
  saveStateBmi: false,
  isOpen: false,
  specialistName: '',
  requestData: {
    attributes: {
      birthdate: '00-xxx-0000',
      gender: '',
      phone: '',
      user_type: '',
      title: '',
      patient_claim_number: '',
      patient_policy_number: ''
    },
    create_subscription: false,
    email: '',
    firstname: '',
    id: '',
    lastname: '',
    message: '',
    password: '',
    patient_id: null,
    phone: '',
    practice: '',
    request_type: 'appointment',
    source_application: 'website',
    token: '',
    uri_id: '',
    employeeId: ''
  },
  submitAttempted: false,
  submitSuccessful: false,
  agreeWithTerms: false,
  loading: false
};

var requestAppointmentModal = function requestAppointmentModal(state, action) {
  var practicesWithEmails = void 0;

  switch (action.type) {
    case _pageActions.LOAD_SPECIALIST_PROFILE + '_RECEIVED':
      var specialist = action.response.specialist;
      var videoConsultation = (0, _helpers.isVideoConsultationAvailable)(specialist);
      practicesWithEmails = (0, _specialistProfile.filterPracticesByEmail)(action.response.practices);

      return (0, _assign2.default)({}, state, {
        specialistName: specialist.name,
        videoConsultation: videoConsultation,
        practices: (0, _specialistProfile.transformPractices)(practicesWithEmails, videoConsultation, action.actionData.hospitalList),
        originalPractices: action.response.practices,
        hasRequestAppointment: specialist.has_request_appointment && specialist.isCore,
        requestData: (0, _extends3.default)({}, state.requestData, {
          id: specialist.id
        })
      });
    case _pageActions.CHOOSE_HOSPITAL_LIST:
      practicesWithEmails = (0, _specialistProfile.filterPracticesByEmail)(state.originalPractices);
      return (0, _assign2.default)({}, state, {
        practices: (0, _specialistProfile.transformPractices)(practicesWithEmails, state.videoConsultation, action.hospitalList)
      });
    case _requestAppointmentModal.OPEN_REQUEST_APPOINTMENT_MODAL:
      {
        var savedStateData = state.saveStateBmi && action.availability ? (0, _assign2.default)({}, state.requestData, {
          availability_id: action.availability.availability_id,
          identifier: action.availability.availability_details.identifier, request_type: action.availability.provider
        }) : {};
        return (0, _assign2.default)({}, action.availability ? INITIAL_STATE : state, {
          saveStateBmi: false,
          isOpen: true,
          requestData: action.availability ? (0, _extends3.default)({}, state.requestData, {
            attributes: {
              birthdate: action.accountProfileData && action.accountProfileData.patient && action.accountProfileData.patient.birthdate || '00-xxx-0000',
              gender: action.accountProfileData && action.accountProfileData.patient && action.accountProfileData.patient.gender || '',
              phone: '',
              user_type: ''
            },
            create_account: false,
            email: action.accountProfileData && action.accountProfileData.patient && action.accountProfileData.patient.email || '',
            firstname: action.accountProfileData && action.accountProfileData.patient && action.accountProfileData.patient.firstname || '',
            lastname: action.accountProfileData && action.accountProfileData.patient && action.accountProfileData.patient.lastname || '',
            message: '',
            password: '',
            patient_id: null,
            phone: '',
            practice: action.availability.practice.id,
            request_type: action.availability.provider,
            source_application: '',
            token: '',
            uri_id: '',
            patient_claim_number: '',
            patient_policy_number: '',
            addressLine: '',
            addressCity: '',
            addressPostcode: '',
            availability_id: action.availability.availability_id,
            identifier: action.availability.availability_details.identifier,
            employeeId: ''
          }, savedStateData) : (0, _extends3.default)({}, state.requestData, {
            attributes: {
              birthdate: action.accountProfileData && action.accountProfileData.patient && action.accountProfileData.patient.birthdate || '00-xxx-0000',
              gender: action.accountProfileData && action.accountProfileData.patient && action.accountProfileData.patient.gender || '',
              title: '',
              phone: '',
              user_type: ''
            },
            create_account: false,
            email: action.accountProfileData && action.accountProfileData.patient && action.accountProfileData.patient.email || '',
            firstname: action.accountProfileData && action.accountProfileData.patient && action.accountProfileData.patient.firstname || '',
            lastname: action.accountProfileData && action.accountProfileData.patient && action.accountProfileData.patient.lastname || '',
            message: '',
            password: '',
            patient_id: null,
            phone: '',
            practice: '',
            request_type: 'appointment',
            source_application: '',
            token: '',
            uri_id: '',
            patient_claim_number: '',
            patient_policy_number: '',
            employeeId: ''
          }),
          submitAttempted: false,
          submitSuccessful: false,
          agreeWithTerms: false,
          availability: action.availability ? action.availability : null,
          hasRequestAppointment: state.hasRequestAppointment,
          practices: state.practices,
          originalPractices: state.originalPractices,
          specialistName: state.specialistName,
          videoConsultation: state.videoConsultation
        });
      }
    case _requestAppointmentModal.CLOSE_REQUEST_APPOINTMENT_MODAL:
      return (0, _assign2.default)({}, state, { isOpen: false });
    case _requestAppointmentModal.CREATE_SUBSCRIPTION_TOGGLE:
      return (0, _assign2.default)({}, state, {
        requestData: (0, _extends3.default)({}, state.requestData, {
          create_subscription: !state.requestData.create_subscription
        })
      });
    case _requestAppointmentModal.PRACTICE_CHANGE:
      return (0, _assign2.default)({}, state, { requestData: (0, _extends3.default)({}, state.requestData, { practice: action.practice }) });
    case _requestAppointmentModal.FIRST_NAME_CHANGE:
      return (0, _assign2.default)({}, state, { requestData: (0, _extends3.default)({}, state.requestData, { firstname: action.name }) });
    case _requestAppointmentModal.LAST_NAME_CHANGE:
      return (0, _assign2.default)({}, state, { requestData: (0, _extends3.default)({}, state.requestData, { lastname: action.name }) });
    case _requestAppointmentModal.SEX_CHANGE:
      return (0, _assign2.default)({}, state, {
        requestData: (0, _extends3.default)({}, state.requestData, {
          attributes: (0, _extends3.default)({}, state.requestData.attributes, { gender: action.gender })
        })
      });
    case _requestAppointmentModal.TITLE_CHANGE:
      return (0, _assign2.default)({}, state, {
        requestData: (0, _extends3.default)({}, state.requestData, {
          attributes: (0, _extends3.default)({}, state.requestData.attributes, { title: action.title })
        })
      });
    case _requestAppointmentModal.PASSWORD_CHANGE:
      return (0, _assign2.default)({}, state, {
        requestData: (0, _extends3.default)({}, state.requestData, {
          attributes: (0, _extends3.default)({}, state.requestData.attributes, { password: action.password })
        })
      });
    case _requestAppointmentModal.EMAIL_CHANGE:
      return (0, _assign2.default)({}, state, { requestData: (0, _extends3.default)({}, state.requestData, { email: action.email }) });
    case _requestAppointmentModal.PHONE_CHANGE:
      return (0, _assign2.default)({}, state, {
        requestData: (0, _extends3.default)({}, state.requestData, {
          phone: action.phone,
          attributes: (0, _extends3.default)({}, state.requestData.attributes, { phone: action.phone })
        })
      });
    case _requestAppointmentModal.DOB_DAY_CHANGE:
      return (0, _assign2.default)({}, state, {
        requestData: (0, _extends3.default)({}, state.requestData, {
          attributes: (0, _extends3.default)({}, state.requestData.attributes, {
            birthdate: state.requestData.attributes && state.requestData.attributes.birthdate.replace(/^\d{2}/, ('0' + action.day).slice(LAST_TWO_CHARS))
          })
        })
      });
    case _requestAppointmentModal.DOB_MONTH_CHANGE:
      var dob = null;

      if (state.requestData.attributes) {
        if (state.requestData.attributes.birthdate.match(/\b[a-zA-Z]{3}\b/)) {
          dob = state.requestData.attributes.birthdate.replace(/\b[a-zA-Z]{3}\b/, action.month);
        } else if (state.requestData.attributes.birthdate.match(/\b-[0-9]{2}-\b/)) {
          dob = state.requestData.attributes.birthdate.replace(/\b-[0-9]{2}-\b/, '-' + action.month + '-');
        }
      }
      return (0, _assign2.default)({}, state, {
        requestData: (0, _extends3.default)({}, state.requestData, {
          attributes: (0, _extends3.default)({}, state.requestData.attributes, {
            birthdate: dob
          })
        })
      });
    case _requestAppointmentModal.DOB_YEAR_CHANGE:
      return (0, _assign2.default)({}, state, {
        requestData: (0, _extends3.default)({}, state.requestData, {
          attributes: (0, _extends3.default)({}, state.requestData.attributes, {
            birthdate: state.requestData.attributes && state.requestData.attributes.birthdate.replace(/\d{4}/, action.year)
          })
        })
      });
    case _requestAppointmentModal.REASON_CHANGE:
      return (0, _assign2.default)({}, state, { requestData: (0, _extends3.default)({}, state.requestData, { message: action.reason }) });
    case _requestAppointmentModal.CLAIM_NUMBER_CHANGE:
      return (0, _assign2.default)({}, state, { requestData: (0, _extends3.default)({}, state.requestData, { patient_claim_number: action.claimNumber }) });
    case _requestAppointmentModal.POLICY_NUMBER_CHANGE:
      // info: this reducer destroys initial state, because it create state.requestData.patient_policy_number,
      // but state architecture is state.requestData.attributes.patient_policy_number
      return (0, _assign2.default)({}, state, {
        requestData: (0, _extends3.default)({}, state.requestData, {
          patient_policy_number: action.policyNumber
        })
      });
    case _requestAppointmentModal.ADDRESS_LINE_CHANGE:
      return (0, _assign2.default)({}, state, { requestData: (0, _extends3.default)({}, state.requestData, { addressLine: action.addressLine }) });
    case _requestAppointmentModal.ADDRESS_CITY_CHANGE:
      return (0, _assign2.default)({}, state, { requestData: (0, _extends3.default)({}, state.requestData, { addressCity: action.addressCity }) });
    case _requestAppointmentModal.ADDRESS_POSTCODE_CHANGE:
      return (0, _assign2.default)({}, state, { requestData: (0, _extends3.default)({}, state.requestData, { addressPostcode: action.addressPostcode }) });
    case _requestAppointmentModal.TOGGLE_POLICY_TERMS_AGREEMENT:
      return (0, _assign2.default)({}, state, { agreeWithTerms: action.agreeWithTerms });
    case _requestAppointmentModal.EMPLOYEE_ID_CHANGE:
      return (0, _assign2.default)({}, state, { requestData: (0, _extends3.default)({}, state.requestData, { employeeId: action.employeeId }) });
    case _requestAppointmentModal.VALIDATION_ERROR:
    case _requestAppointmentModal.SUBMIT_REQUEST + '_REQUESTED':
      return (0, _assign2.default)({}, state, { submitAttempted: true });
    case _requestAppointmentModal.SUBMIT_REQUEST + '_RECEIVED':
      return (0, _assign2.default)({}, state, { submitSuccessful: true, loading: false });
    case _requestAppointmentModal.SUBMIT_REQUEST + '_FAILED':
      if (action.error && (action.code === 409 || action.code === 500)) {
        return (0, _assign2.default)({}, state, { submitSuccessful: false, saveStateBmi: true, isOpen: false, loading: false });
      }
      return (0, _assign2.default)({}, state, { submitSuccessful: false, loading: false });
    case _requestAppointmentModal.SUBMIT_REQUEST:
      return (0, _assign2.default)({}, state, { loading: true });
    default:
      return state || INITIAL_STATE;
  }
};

exports.default = requestAppointmentModal;


// WEBPACK FOOTER //
// ./components/specialist-page/lib/reducers/request-appointment-modal.js